/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/BasePanel.Props" />
import { IButtonProps } from "VSSUI/Button";
import { ContentSize } from "VSSUI/Callout";

export interface IBasePanelProps {
    onDismiss: () => void;
    onDismissErrorMessage?: () => void;
    title?: string;
    onRenderHeaderContent?: () => JSX.Element;
    onRenderPanelFooter?: () => JSX.Element | undefined;
    className?: string;
    errorMessage?: string | JSX.Element;
    warningMessage?: string;
    // Setting this will automatically disable the content and footer and show a spinner on the panel with the
    // given message. Header of the panel will still be shown, though.
    loadingSpinnerMessage?: string;
    /**
     * Size of the panel.
     * @default ContentSize.Large
     */
    size?: ContentSize;
    /**
     * If the header should show a close button.
     * @default: true
     */
    showCloseButton?: boolean;

     /**
     * If these props are provided, the panel's header will draw a back button before the panel
     * header's title. By default this will use a subtle button with the "Back" icon,
     * but these props can override those choices.
     */
    backButtonProps?: IButtonProps;
}
